module.exports = __webpack_public_path__ + "assets/57e2e6b93a2d57151aa76879c2389d3b.mp4";